import { Injectable, Inject } from 'ng-metadata/core';
import { loadCSS, loadScript, loadScriptWithModuleType } from './scriptLoader';
import {ConfigurationUtil} from "./nddUtils/configurationUtil.service";

const injector = angular.injector(['ng']);
const $q: ng.IQService = injector.get('$q');

const { once, clone,get } = require("lodash");


@Injectable()
export class DigitalEpubStartService {

	private isEpubEnabled: boolean;

	constructor( 
         @Inject('$state') private $state: ng.ui.IStateService,
		private configurationUtil: ConfigurationUtil,
         @ Inject('$q') private $q: ng.IQService) {
		      this.isEpubEnabled = this.configurationUtil.getFeatureFlag('epub_via_alma_viewer');
		}

	public loadEpubCSSAndJavascript() {
		if (this.isEpubEnabled) {
			let p1 = this.loadCss("lib/bower_components/epub-foliate-viewer/reader.css");
			let p2 = this.loadJsWithModuleType("lib/bower_components/epub-foliate-viewer/reader.js");
			return this.$q.all([p1,p2]);
		}
		return null;
	}   
    // methods to load ePub reader.js and redear.css dynamically
	
	private loadJsWithModuleType(jsFile) {
	    let deferred = this.$q((resolve)=> {
	        if(jsFile) {
	            loadScriptWithModuleType(jsFile).then(
	                ()=> resolve(true),
	                ()=> resolve(false)
	            );
	        }
	        else {
	            resolve(false);
	        }
	
	
	    });
		return deferred;
	}
	
	private loadCss(cssFile) {
	let myinstance = this;
	    let deferred = this.$q((resolve)=> {
	    if(cssFile) {
	            loadCSS(cssFile).then(
	                ()=> resolve(true),
	                ()=> resolve(false)
	            );
	        }
	        else {
	            resolve(false);
	        }
	
	
	    });
		return deferred;
	}
	
	
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/digitalEpubStart.service.ts